export default "__VITE_ASSET__BVqSqOPk__"